// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YL74","placeholdersHeader":"styles_placeholdersHeader__2YJg4","editorStyle":"styles_editorStyle__2Tbh1","placeholdersBox":"styles_placeholdersBox__3RDCt"};